export default "__VITE_ASSET__Cl6BrWLg__"